export default [
    {
        path: '/highlights',
        name: 'highlights',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Highlights.vue')
    }
]
